import { hasProperty } from '../util';
export function isLayerSpec(spec) {
    return hasProperty(spec, 'layer');
}
//# sourceMappingURL=layer.js.map